// extracted by mini-css-extract-plugin
module.exports = {"OrgSortModalBase":"OrgSortModal_OrgSortModalBase__3ITDC","OrgSortModalItem":"OrgSortModal_OrgSortModalItem__2XX13","OrgSortModalItemAct":"OrgSortModal_OrgSortModalItemAct__2fMhs"};